import { useLocation } from 'react-router-dom'

interface VisibilityFilterScope {
  /** Wind-load overlays are hidden on the IFC import page. */
  showWindLoads: boolean
  /** Support overlays (vertical/tension) are hidden on the IFC import and global-loads pages. */
  showSupports: boolean
}

/**
 * Which "Weiteres" visibility overlays are available on the current editor page. Single source of
 * truth shared by the switches (VisibilitySwitches) and the badge/bulk-toggle
 * (useExtraVisibilityFilters) so they stay in sync.
 */
const useVisibilityFilterScope = (): VisibilityFilterScope => {
  const { pathname } = useLocation()
  const isIfcView = pathname.includes('/ifc-import')
  const isGlobalLoadsView = pathname.includes('/global-loads')

  return {
    showWindLoads: !isIfcView,
    showSupports: !isIfcView && !isGlobalLoadsView,
  }
}

export default useVisibilityFilterScope
